import { HotelsFlexModuleResult } from "typings/microserviceModels/hotels-flex-module";
import { UitkLink } from "uitk-react-link";
import { TrackedLink } from "components/utility/analytics/TrackedLink";
import * as React from "react";
import { LocalizedComponentProps, LocalizedText } from "bernie-l10n";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { isVariantEnabled, Experiment } from "components/utility/experiment";

interface SeeAllContentLinkProps extends LocalizedComponentProps {
  model: HotelsFlexModuleResult;
  context: ExtendedContextStore;
  affinityDescription: string;
}

/**
 * Link that will bring the user to a list of all hotels at once instead of top 10
 * @param props
 */
export const SeeAllContentLink = (props: SeeAllContentLinkProps) => {
  const { model, context, affinityDescription } = props;
  const { seeAllLink, showMoreStrategy, locationName } = model;

  if (
    !seeAllLink ||
    isVariantEnabled(context, Experiment.Blossom_SRP_Lite_Mobile) ||
    (showMoreStrategy !== "top_link" && showMoreStrategy !== "button")
  ) {
    return null;
  }

  let seeAllMessage;
  let seeAllParams;

  if (affinityDescription) {
    seeAllMessage = "hotels.affinity.seeMoreProperties";
    seeAllParams = [affinityDescription, locationName];
  } else {
    seeAllMessage = "hotels.seeAllAvailableProperties";
    seeAllParams = [locationName];
  }

  return (
    <div className="see-all-hotels" data-testid="see-all-content-link">
      <UitkLink>
        <TrackedLink
          moduleName={model.name}
          href={seeAllLink}
          rfrr={model.seeAllType}
          linkName={seeAllLink}
          rel="nofollow"
        >
          <LocalizedText message={seeAllMessage} data={seeAllParams} />
        </TrackedLink>
      </UitkLink>
    </div>
  );
};
